import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { updateStep } from "../../../redux/profileFormSlice";
import FileUploader from "../../../components/SimpleFileDropper/FileUploader";

const getFileName = (file) =>
  typeof file === "string" ? file : file?.name || "";

const DocumentsUpload = () => {
  const dispatch = useDispatch();
  const stepData = useSelector((state) => state.profileForm.step6); 

  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      profileImage: stepData?.profileImage || "",
      cv: stepData?.cv || "",
    },
  });

  useEffect(() => {
    const subscription = watch((values) =>
      dispatch(updateStep({ step: "step6", data: values })) 
    );
    return () => subscription.unsubscribe();
  }, [watch, dispatch]);

  return (
    <div>
      <div className="text-center mb-8">
        <h3 className="text-xl font-bold text-gray-800 mb-2">Documents Upload</h3>
        <p className="text-sm text-gray-500">
          Upload your documents to enhance your profile (Optional)
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FileUploader
          name="profileImage"
          label="Your photo"
          register={register}
          errors={errors}
          placeholder="Your Photo"
          defaultValue={getFileName(stepData?.profileImage)}
          accept="image/*"
          onFileSelect={(file) => setValue("profileImage", file || "")}
        />
        <FileUploader
          name="cv"
          label="CV"
          errors={errors}
          placeholder="Your CV"
          defaultValue={getFileName(stepData?.cv)}
          accept=".pdf,.doc,.docx,.txt,.rtf"
          onFileSelect={(file) => setValue("cv", file || "")}
        />
      </div>
    </div>
  );
};

export default DocumentsUpload;
